import Compressor from 'compressorjs'

export function PromiseCompressor({ file, options }: { file: File; options: Compressor.Options }) {
  return new Promise((resolve: (value: File) => void, reject: (error: Error) => void) => {
    return new Compressor(file, {
      ...options,
      success: (compressedFile: File) => {
        resolve(compressedFile)
      },
      error: (error) => {
        reject(error)
      },
    })
  })
}

export function getNewDimension({ height, width, maxDimensionForSortSide = MAX_DIMENSION_FOR_SORT_SIDE }: { height: number; width: number; maxDimensionForSortSide?: number }) {
  const sortSide = height > width ? width : height

  const newDimension: {
    height?: number
    width?: number
  } = {}

  if (sortSide > maxDimensionForSortSide) {
    if (sortSide === height) {
      newDimension.height = maxDimensionForSortSide
    } else {
      newDimension.width = maxDimensionForSortSide
    }
  }

  return newDimension
}

export const QUALITY_COMPRESSION = 0.85
export const MAX_DIMENSION_FOR_SORT_SIDE = 1400
